import {useMinimumQuantityNotice} from "../../../../hooks/useMinimumQuantityNotice";
import * as React from "react";

export const MinimumQuantityNotice = ({minimumQuantity}: { minimumQuantity: number }) => {
    const {className} = useMinimumQuantityNotice(minimumQuantity);
    return (<small className={className}> Minimum quantity: {minimumQuantity}</small>);
};